import { z } from 'zod';

// ---------------------------------------------------------------------------
// G-TEL: POST /v1/telemetry/web-vitals — unauthenticated CWV ingest
// ---------------------------------------------------------------------------

export const WebVitalsIngestSchema = z.object({
  domain: z.enum(['wandero.de', 'wallart.com', 'wandero.pl']),
  page_path: z.string().max(2048),
  metric_name: z.enum(['LCP', 'INP', 'CLS', 'FCP', 'TTFB']),
  value: z.number().nonnegative(),
  rating: z.enum(['good', 'needs-improvement', 'poor']).optional(),
  navigation_type: z.string().max(64).optional(),
});
export type WebVitalsIngest = z.infer<typeof WebVitalsIngestSchema>;

export const WebVitalsIngestResponseSchema = z.object({
  accepted: z.literal(true),
});
export type WebVitalsIngestResponse = z.infer<typeof WebVitalsIngestResponseSchema>;
